import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import DefaultUserBar from './UserBar';
import UserBarResponsive from './UserBarResponsive';

const UserBar = (props) => {
  const { webAppFtResponsiveNavBar20254 } = useFlags();

  return webAppFtResponsiveNavBar20254 ? (
    <UserBarResponsive {...props} />
  ) : (
    <DefaultUserBar {...props} />
  );
};

export default UserBar;
